"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Contact", {
  enumerable: true,
  get: function () {
    return _contact.default;
  }
});
Object.defineProperty(exports, "Ribbon", {
  enumerable: true,
  get: function () {
    return _ribbon.default;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function () {
    return _Search.default;
  }
});
Object.defineProperty(exports, "Social", {
  enumerable: true,
  get: function () {
    return _social.default;
  }
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _contact = _interopRequireDefault(require("./contact"));

var _ribbon = _interopRequireDefault(require("./ribbon"));

var _social = _interopRequireDefault(require("./social"));

var _Search = _interopRequireDefault(require("./Search"));

var _Document = _interopRequireDefault(require("./Document"));

const _excluded = ["name", "type", "className"];

const Icon = _ref => {
  let {
    name,
    type,
    className
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  switch (name) {
    case 'contact':
      return /*#__PURE__*/_react.default.createElement(_contact.default, (0, _extends2.default)({}, props, {
        type: type,
        className: className
      }));

    case 'ribbon':
      return /*#__PURE__*/_react.default.createElement(_ribbon.default, (0, _extends2.default)({}, props, {
        type: type,
        className: className
      }));

    case 'social':
      return /*#__PURE__*/_react.default.createElement(_social.default, (0, _extends2.default)({}, props, {
        type: type,
        className: className
      }));

    case 'search':
      return /*#__PURE__*/_react.default.createElement(_Search.default, (0, _extends2.default)({}, props, {
        className: className
      }));

    case 'document':
      return /*#__PURE__*/_react.default.createElement(_Document.default, (0, _extends2.default)({}, props, {
        className: className
      }));

    default:
      return /*#__PURE__*/_react.default.createElement(_Search.default, (0, _extends2.default)({}, props, {
        type: type,
        className: className
      }));
  }
};

Icon.defaultProps = {
  className: ''
};
Icon.propTypes = {
  name: _propTypes.default.string.isRequired,
  type: _propTypes.default.string.isRequired,
  className: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;